import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};
import { Toaster } from 'react-hot-toast';
import { useAuthStore } from './store/authStore';
import { Layout } from './components/layout/Layout';
import { LoginPage } from './pages/verve-login/screens/LoginPage';
import { DashboardPage } from './pages/verve-dashboard/screens/DashboardPage';
import { HomePage } from './pages/verve-home/screens/HomePage';
import ContactScreen from './pages/verve-contacts/screens/contactScreen';
import LeadsScreen from './pages/verve-leads/leads/screens/LeadsScreen';
import ApprovalsScreen from './pages/verve-approvals/screens/ApprovalsScreen';



// static component
// import { DesignPage } from './pages/DesignPage';
// correct one
import ProjectsScreen from './pages/verve-projects/screens/ProjectsScreen';
// static component
// import { ProjectsPage } from './pages/ProjectsPage';
import { InventoryScreen } from './pages/verve-inventory/screens/InventoryScreen';
// correct one
import AccountsScreen from './pages/verve-accounts/screens/AccountsScreen';
// static component
// import { AccountsPage } from './pages/AccountsPage';
import { AnalyticsPage } from './pages/AnalyticsPage';
import { UsersPage } from './pages/UsersPage';
import { SettingsPage } from './pages/SettingsPage';
import { NotificationsPage } from './pages/NotificationsPage';
import DocumentsScreen from './pages/verve-documents/screens/DocumentsScreen';
import ExcelEditorScreen from './pages/verve-documents/screens/ExcelEditorScreen';
import WordEditorScreen from './pages/verve-documents/screens/WordEditorScreen';
import { DesignSystemPage } from './pages/DesignSystemPage';
import { ProjectDetailsScreen } from './pages/verve-projects/verve-projects-flow/screens/ProjectDetailsScreen';
import AutoCADScreen from './pages/verve-autocad/screens/AutoCADScreen';
import './styles/index.css';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuthStore();
  return isAuthenticated ? <Layout>{children}</Layout> : <Navigate to="/login" replace />;
};

function App() {
  const { isAuthenticated } = useAuthStore();

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 3000,
          style: { fontFamily: "'DM Sans', sans-serif", fontSize: '14px', borderRadius: '10px', border: '1px solid #F0F0F0', boxShadow: '0 4px 12px rgba(0,0,0,0.08)' },
          success: { iconTheme: { primary: '#10B981', secondary: 'white' } },
          error: { iconTheme: { primary: '#EF4444', secondary: 'white' } },
        }}
      />
      <Routes>
        <Route path="/home" element={<HomePage />} />
        <Route path="/contacts" element={<ProtectedRoute><ContactScreen /></ProtectedRoute>} />
        <Route path="/login" element={isAuthenticated ? <Navigate to="/home" replace /> : <LoginPage />} />
        <Route path="/" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
        <Route path="/leads" element={<ProtectedRoute><LeadsScreen /></ProtectedRoute>} />
        <Route path="/approvals" element={<ProtectedRoute><ApprovalsScreen /></ProtectedRoute>} />

        <Route path="/design-system" element={<ProtectedRoute><DesignSystemPage /></ProtectedRoute>} />
        {/* static component */}
        {/* <Route path="/projects-static" element={<ProtectedRoute><ProjectsPage /></ProtectedRoute>} /> */}
        {/* correct one */}
        <Route path="/projects" element={<ProtectedRoute><ProjectsScreen /></ProtectedRoute>} />
        <Route path="/projects/:id" element={<ProtectedRoute><ProjectDetailsScreen /></ProtectedRoute>} />
        <Route path="/inventory" element={<ProtectedRoute><InventoryScreen /></ProtectedRoute>} />
        {/* static component */}
        {/* <Route path="/accounts-static" element={<ProtectedRoute><AccountsPage /></ProtectedRoute>} /> */}
        {/* correct one */}
        <Route path="/accounts" element={<ProtectedRoute><AccountsScreen /></ProtectedRoute>} />
        <Route path="/analytics" element={<ProtectedRoute><AnalyticsPage /></ProtectedRoute>} />
        <Route path="/users" element={<ProtectedRoute><UsersPage /></ProtectedRoute>} />
        <Route path="/documents" element={<ProtectedRoute><DocumentsScreen /></ProtectedRoute>} />
        <Route path="/documents/edit/:id" element={<ProtectedRoute><ExcelEditorScreen /></ProtectedRoute>} />
        <Route path="/documents/edit-word/:id" element={<ProtectedRoute><WordEditorScreen /></ProtectedRoute>} />
        <Route path="/settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
        <Route path="/notifications" element={<ProtectedRoute><NotificationsPage /></ProtectedRoute>} />
        <Route path="/autocad" element={<ProtectedRoute><AutoCADScreen /></ProtectedRoute>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
